import { MeterEventType } from '@enmon/commons/lib/tools';

export const METER_EVENTS_TRANSLATED: Record<MeterEventType, string> = {
  [MeterEventType.Create]: 'created',
  [MeterEventType.Update]: 'updated',
  [MeterEventType.InventorizeCreate]: 'inventorize (created)',
  [MeterEventType.InventorizeUpdate]: 'inventorize (updated)',
  [MeterEventType.Installation]: 'installed',
  [MeterEventType.Replacement]: 'replaced',
  [MeterEventType.ServiceInspection]: 'service inspected',
  [MeterEventType.Sync]: 'synced',
  [MeterEventType.Activate]: 'activated',
  [MeterEventType.Deactivate]: 'deactivated',
  [MeterEventType.BulkChange]: 'bulk changed',
  [MeterEventType.Merge]: 'merged',
  [MeterEventType.Review]: 'reviewed',
};

export const METER_EVENT_TYPE_TO_COLOR_MAP: Record<MeterEventType, string> = {
  [MeterEventType.Create]: 'green',
  [MeterEventType.Update]: 'blue',
  [MeterEventType.InventorizeCreate]: 'green',
  [MeterEventType.InventorizeUpdate]: 'blue',
  [MeterEventType.Installation]: 'green',
  [MeterEventType.Replacement]: 'red',
  [MeterEventType.ServiceInspection]: 'gray',
  [MeterEventType.Sync]: 'blue',
  [MeterEventType.Activate]: 'green',
  [MeterEventType.Deactivate]: 'red',
  [MeterEventType.BulkChange]: 'gray',
  [MeterEventType.Merge]: 'blue',
  [MeterEventType.Review]: 'green',
};
